/* Class and set of functions for communication with Feide and Dataporten */
import axios from 'axios'
//const jwtDecode = require('jwt-decode')
import { jwtDecode } from 'jwt-decode'

export class FeideTools {
  constructor(accessToken, idToken) {
    console.log(
      '-------------FeideTools---------- Constructor : (%s) (%s)',
      accessToken,
      idToken
    )
    // console.log(idToken)
    this.token = accessToken
    this.idToken = idToken
    this.feideUserServer = 'https://api.dataporten.no'
    this.feideGroupServer = 'https://groups-api.dataporten.no'
    this.feideAuthServer = 'https://auth.dataporten.no'
    this.feideAPIServer = 'https://api.feide.no'
    this.udirAPIServer = 'https://data-nsr.udir.no'
  }

  isLoggedIn(clientToken) {
    // console.error('=== jwtToken === (' + clientToken + ')')
    if (clientToken === undefined) {
      /*
      throw new Error({
        error: 'Not logged in (no client token) !'
      })
      */
      return false
    }
    let jwtToken = jwtDecode(clientToken)
    // console.error('=== jwtToken')
    // console.log(jwtToken)
    let tokenExpire = jwtToken.exp
    // console.log('isLoggedIn: tokenExpire (' + tokenExpire + ')')
    if (isTokenExpired(tokenExpire)) {
      /*
      throw new Error({
        error: 'Not logged in (token expired) !'
      })
      */
      return false
    }
    return true
  }

  getAxiosConnection(url, path) {
    // let accessClientToken = localStorage.getItem('access_client_token')
    // let url = context.getters.getServerUrl
    console.log('getAxiosConnection url(' + url + ') path(' + path + ')')
    return axios.create({
      baseURL: url + path,
      // timeout: 5000,
      timeout: 10000,
      responseType: 'json', // default
      responseEncoding: 'utf8', // default
      maxRedirects: 5 // default
    })
  }

  getUserInfo() {
    return new Promise((resolve, reject) => {
      // console.log('getUserInfo got called ! : ' + this.token)
      const instance = this.getAxiosConnection(this.feideAuthServer, '/openid')
      instance
        .get('/userinfo', {
          headers: {
            Authorization: `Bearer ${this.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.error('*** ERROR *** getUserInfo:' + error)
          reject(new Error('*** ERROR *** getUserInfo:' + error))
        })
    })
  }

  getBasicUserInfo() {
    // let serverUrl = 'https://api.dataporten.no'
    console.log('getBasicUserInfo got called:')
    console.log(this.token)
    const instance = this.getAxiosConnection(
      this.feideUserServer,
      '/userinfo/v1'
    )
    return new Promise((resolve, reject) => {
      instance
        .get('/userinfo', {
          headers: {
            Authorization: `Bearer ${this.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }
        })
        .then((response) => {
          console.log('basicUserInfo is:')
          console.log(response.data)
          resolve(response.data)
        })
        .catch((error) => {
          console.error('getBasicUserInfo had problems !: ' + error)
          reject(new Error('getBasicUserInfo had problems !: ' + error))
        })
    })
  }

  /* ********* GROUPS ********** */
  /* https://docs.feide.no/developer_oauth/technical_details/groups_api.html */
  getAllGroups() {
    return new Promise((resolve, reject) => {
      // console.log('getAllGroups got called ! : ' + this.token)
      const instance = this.getAxiosConnection(this.feideGroupServer, '/groups')
      instance
        .get('/me/groups', {
          headers: {
            Authorization: `Bearer ${this.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.error('*** ERROR *** getAllGroups:' + error)
          reject(new Error('*** ERROR *** getAllGroups:' + error))
        })
    })
  }

  getGroupMembers(groupID) {
    return new Promise((resolve, reject) => {
      // console.log('getAllGroups got called ! : ' + this.token)
      const instance = this.getAxiosConnection(this.feideGroupServer, '/groups')
      let groupQuery = '/groups/' + groupID + '/members'
      console.log('groupQuery is:(' + groupQuery + ')')
      instance
        .get(groupQuery, {
          headers: {
            Authorization: `Bearer ${this.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }
        })
        .then((response) => {
          // console.log(response.data)
          resolve(response.data)
        })
        .catch((error) => {
          console.error('*** ERROR *** getGroupMembers:' + error)
          reject(new Error('*** ERROR *** getGroupMembers:' + error))
        })
    })
  }
  /*
    getAllGroups_extra() {
      return new Promise((resolve, reject) => {
        console.log('getAllGroups got called ! : ' + token)
        const instance = getAxiosConnection(this.feideGroupServer, '/groups')
        instance.get('/groups', {
            headers: {
              Authorization: `Bearer ${this.token}`,
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            console.error('*** ERROR *** getUserInfo:' + error)
            reject(new Error('*** ERROR *** getUserInfo:' + error))
          })
      })
    }
  */
  getAllOrganisations() {
    console.log('getAllOrganisations got called')
    return new Promise((resolve, reject) => {
      // console.log('getAllOrganisations got called ! : ' + this.token)
      const instance = this.getAxiosConnection(this.udirAPIServer, '')
      instance
        .get('/kommuner', {
          headers: {
            //  Authorization: `Bearer ${this.token}`, // OPEN API
            // 'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }
        })
        .then((response) => {
          let orgs = response.data
          let activeOrgs = []
          orgs.forEach((value) => {
            if (!value.ErNedlagt && value.OrgNr) {
              activeOrgs.push({
                kommunenavn: value.Navn,
                kommuneorgnr: value.OrgNr
              })
            }
          })
          // console.log('got the following Active organisations')
          // console.log(activeOrgs)
          resolve(activeOrgs)
        })
        .catch((error) => {
          console.error('*** ERROR *** getAllOrganisations:' + error)
          reject(new Error('*** ERROR *** getAllOrganisations:' + error))
        })
    })
  }

  getFeideShcools(kommuneorgnr) {
    // console.log('getFeideShcools got called (' + kommuneorgnr + ')')
    return new Promise((resolve, reject) => {
      if (kommuneorgnr === undefined) {
        reject(new Error('NO kommunenr defined'))
      }
      let kommunenr = kommuneorgnr.substr(2)
      // /trestruktur/940039541/1
      let query = '/trestruktur/' + kommunenr + '/1'
      const instance = this.getAxiosConnection(this.udirAPIServer, query)
      // console.log('QUERY : ' + query)
      instance
        .get('', {
          headers: {
            //  Authorization: `Bearer ${this.token}`, // OPEN API
            // 'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }
        })
        .then((response) => {
          // console.log(response.data.Children)
          let schools = response.data.Children
          let returnSchools = []
          schools.forEach((value) => {
            returnSchools.push({
              skolenavn: value.Navn,
              skoleorgnr: value.OrgNr
            })
          })
          // console.log('got the following Active organisations')
          // console.log(activeOrgs)
          resolve(returnSchools)
        })
        .catch((error) => {
          console.error('*** ERROR *** getAllOrganisations:' + error)
          reject(new Error('*** ERROR *** getAllOrganisations:' + error))
        })
    }) // promise
  }

  /* Method for extracting "groups" of a specific type [u,b] */
  getFeideGroups(groups, type) {
    // console.log('getFeideAGroups')
    // console.log(groups)
    let feideGroups = []
    let length = groups.length
    for (let i = 0; i < length; i++) {
      let item = groups[i]
      if (
        item !== undefined &&
        item.go_type !== undefined &&
        item.go_type === type
      ) {
        feideGroups.push(item)
      }
    }
    /*
    groups.forEach((value, index, array) => {
      if (value.go_type === type) {
        // console.log('==== WE HAVE GO_TYPE === ' + type)
        // console.log(value)
        feideGroups.push(value)
      }
    })
    */
    return feideGroups
  }

  getFeideOrgGroups(groups) {
    // console.log('getFeideOrgGroups')
    //  console.log(groups)
    let feideOrgGroups = []
    // groups.forEach((value, index, array) => {
    groups.forEach((value) => {
      if (
        value !== undefined &&
        value.type !== undefined &&
        value.type === 'fc:org'
      ) {
        console.log('==== WE HAVE FC:ORG === ' + value.type)
        // console.log(value)
        feideOrgGroups.push(value)
      }
    })
    return feideOrgGroups
  }

  getFeideEnrichUGroup(uGroups) {
    console.log('getFeideEnrichUGroup got called')
    //  let enrichedGroups = []
    //    uGroups.forEach((value, index, array) => {
    uGroups.forEach((value) => {
      console.error('*** NOT USED *** getFeideEnrichUGroup (%o', value)
    })
  }

  getFeideNorEduOrgNin(groups) {
    console.log('getFeideNorEduOrgNin got called')
    let municipalityNorEduOrgNin = ''
    let municipalityDisplayName = ''
    let schoolNorEduOrgNin = ''
    let schoolDisplayName = ''
    //    groups.forEach((value, index) => {
    groups.forEach((value) => {
      if (value.type === 'fc:org') {
        // console.log('================ FC:ORG ==========')
        // console.log(JSON.stringify(value))
        if (value.orgType[0] === 'primary_and_lower_secondary_owner') {
          municipalityNorEduOrgNin = value.norEduOrgNIN
          municipalityDisplayName = value.displayName
        } else if (value.orgType[0] === 'primary_and_lower_secondary') {
          schoolDisplayName = value.displayName
          let id = value.id
          let idSplit = id.split(':')
          // console.log(idSplit)
          schoolNorEduOrgNin = idSplit[4]
        }
      }
    })
    return {
      municipalityNorEduOrgNin: municipalityNorEduOrgNin,
      municipalityDisplayName: municipalityDisplayName,
      schoolNorEduOrgNin: schoolNorEduOrgNin,
      schoolDisplayName: schoolDisplayName
    }
  }

  getFeideSchoolClass(bGroups) {
    /* fc:gogroup:spusers.feide.no:b:NO856326499:10a:2016-01-01:2019-06-20 */
    let bId = ''
    //    bGroups.forEach((value, index) => {
    bGroups.forEach((value) => {
      bId = value.id
    })
    console.log('=== BID === (' + bId + ')')
    let idSplit = bId.split(':')
    let eduNIN = idSplit[5] || ''
    return eduNIN.toUpperCase()
  }
}

export function isAuthenticated() {
  let tokenExpiration = localStorage.getItem('tokenexpire')
  return !!tokenExpiration && tokenExpiration < new Date()
}

function isTokenExpired(token) {
  let expirationDate = getTokenExpirationDate(token)
  return expirationDate < new Date()
}

function getTokenExpirationDate(encodedToken) {
  let date = new Date(0)
  date.setUTCSeconds(encodedToken)
  return date
}
